import GrapesJsEmailEditor from './GrapesJsEmailEditor.vue';

export default {
  GrapesJsEmailEditor,
};
